'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPulseStrong = function IoIosPulseStrong(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.8 21.3c2.1 0 3.7 1.6 3.7 3.7s-1.6 3.8-3.7 3.8c-1.7 0-3-1-3.6-2.4h-3.9c-0.6 0-1.1-0.3-1.2-0.9l-1.3-3.6-3.9 13.5c-0.1 0.5-0.6 0.9-1.1 0.9h-0.1c-0.6 0-1.1-0.4-1.2-1l-4-24-3.5 14.2c-0.2 0.5-0.7 0.9-1.2 0.9h-8.8v-2.5h7.7l4.8-19.1c0.2-0.6 0.6-1.1 1.3-1.1s1.1 0.6 1.2 1.1l4.1 24.6 3.5-12.1c0.1-0.6 0.6-0.9 1.1-0.9 0.6 0 1.1 0.3 1.2 0.9l2.3 6.6h3c0.4-1.5 1.9-2.6 3.6-2.6z' })
        )
    );
};

exports.default = IoIosPulseStrong;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-pulse-strong.js
// module id = 2493
// module chunks = 0